export enum AgentBookAppointmentStepsRoutes {
  settingAgent = 'setting-agent',
  connectCalendar = 'connect-calendar',
  actionsAgent = 'actions-agent',
  activateAgent = 'activate-agent',
}

export enum AgentSteps {
  STEP1 = 'step_1',
  STEP2 = 'step_2',
  STEP3 = 'step_3',
  STEP4 = 'step_4',
}

export const AgentBookAppointmentRouteToStepMap = {
  [AgentBookAppointmentStepsRoutes.settingAgent]: AgentSteps.STEP1,
  [AgentBookAppointmentStepsRoutes.connectCalendar]: AgentSteps.STEP2,
  [AgentBookAppointmentStepsRoutes.actionsAgent]: AgentSteps.STEP3,
  [AgentBookAppointmentStepsRoutes.activateAgent]: AgentSteps.STEP4,
} as const
